module.exports = __webpack_public_path__ + "static/blog40-0b2406d362f0583a063de813c9d1d78c.png";